/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { MODAL_SCREENS } from '../../constants';
import { showAlert } from '../../../../utilities/notifications';
import { OTC_TRADE } from '../../mutations';

const CommunicateOptions = ({ form, openScreen, hide }) => {
  const { t: translate } = useTranslation();

  const { mutate: otcTrade, isLoading } = useMutation(OTC_TRADE, {
    onSettled(_, error) {
      if (!error) {
        showAlert({
          message: translate('OTC_request_success_msg'),
          type: 'success',
          blockAutoDismiss: true,
          showIcon: true,
        });
        hide();
      } else {
        showAlert({ message: error.message, type: 'danger' });
        hide();
      }
    },
  });

  const options = [
    {
      label: translate('whatsapp_option_label'),
      disabled: false,
      image: './assets/icons/whatsapp.svg',
      type: 'whatsapp',
    },
    {
      label: translate('telegram_option_label'),
      disabled: false,
      image: './assets/icons/telegram.svg',
      type: 'telegram',
    },
  ];

  const handleOnClick = (type) => {
    otcTrade({
      source_currency: form?.source?.currency_code,
      destination_currency: form?.destination?.currency_code,
      source_amount: form?.sourceAmount,
      destination_amount: form?.destinationAmount,
      trade_type: form?.tradeType,
      contact_method: type,
    });
  };

  const renderButton = ({ disabled, type, label, image, key }) => (
    <div
      key={key}
      role="button"
      tabIndex="-1"
      onClick={!isLoading ? () => handleOnClick(type) : () => {}}
      onKeyDown={!isLoading ? () => handleOnClick(type) : () => {}}
      className={`bg-light cursor-pointer hover-container rounded-3 p-4 d-flex flex-row justify-content-between align-items-center mb-3 ${
        disabled ? 'd-none' : ''
      }`}>
      <div className="d-flex flex-row gap-1 align-items-center">
        <img className="me-2" style={{ width: '2rem', height: '2rem' }} alt={type} src={image} />
        <p>{label}</p>
      </div>
      <i
        style={{ width: '1rem' }}
        className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
        role="button"
        aria-label={label}
        tabIndex={0}
        onKeyDown={() => {}}
        onClick={() => {}}
      />
    </div>
  );

  return (
    <ModalBodyLayout
      title={translate('OTC_communication_option_modal_title')}
      onPrevClick={() => openScreen(MODAL_SCREENS.SALES)}
      withBack
      isScrollable>
      <p className="text-white text-f5 my-4">{translate('get_quote_modal_note')}</p>

      {options.map((item) =>
        renderButton({
          label: item.label,
          image: item.image,
          type: item.type,
          key: item.type,
          disabled: item.disabled,
        })
      )}
    </ModalBodyLayout>
  );
};

export default CommunicateOptions;

CommunicateOptions.propTypes = {
  form: PropTypes.object.isRequired,
  openScreen: PropTypes.func.isRequired,
  hide: PropTypes.func.isRequired,
};
